import { takeEvery, call, put, all, fork } from 'redux-saga/effects';
import * as UrlUtil from '../utils/UrlUtil';
import {
    FETCH_ACTIVITY_SUMMARY,
    FETCH_ACTIVITY_SUMMARY_SUCCESS,
    FETCH_ACTIVITY_SUMMARY_GROUPED_SUCCESS,
    FETCH_ACTIVITY_SUMMARY_WEEKLY_GROUPED_SUCCESS,
    FETCH_ACTIVITY_SUMMARY_WEEKLY,
    FETCH_ACTIVITY_SUMMARY_WEEKLY_SUCCESS,
    FETCH_ACTIVITY_SUMMARY_MONTHLY,
    FETCH_ACTIVITY_SUMMARY_MONTHLY_SUCCESS,
    FETCH_ACTIVITY_SUMMARY_MONTHLY_GROUPED_SUCCESS,
    FETCH_ACTIVITY_SUMMARY_YEARLY,
    FETCH_ACTIVITY_SUMMARY_YEARLY_SUCCESS,
    FETCH_ACTIVITY_SUMMARY_YEARLY_GROUPED_SUCCESS,
    FETCH_ACTIVITY_SUMMARY_STATS,
    FETCH_ACTIVITY_SUMMARY_STATS_ACTIVITY_SUCCESS,
    FETCH_ACTIVITY_SUMMARY_STATS_EVENT_SUCCESS,
    SUBMIT_ACTIVITY_FEEDBACK,
    SUBMIT_ACTIVITY_FEEDBACK_SUCCESS,
    REQUEST_ACTIVITY_TYPES,
    RECEIVE_ACTIVITY_TYPES,
    ACTIVITY_TYPES_FAIL,
    REQUEST_ACTIVITY_HR_TIME_IN_ZONE,
    REQUEST_ACTIVITY_POWER_TIME_IN_ZONE,
    FETCH_CHARTS_ORDER,
    FETCH_FAVORITE_ACTIVITIES,
    FETCH_ACTIVITIES,
    FETCH_ACTIVITY_HR_TIME_IN_ZONE,
    FETCH_ACTIVITIES_BY_SEARCH,
    REQUEST_ACTIVITIES_BY_SEARCH,
    RECEIVE_ACTIVITIES_BY_SEARCH,
    RECEIVE_ACTIVITIES_BY_SEARCH_ERROR,
    FAVORITE_ACTIVITY,
    RECEIVE_FAVORITE_ACTIVITY,
    DELETE_ACTIVITY_BY_SEARCH,
    RECEIVE_DELETE_ACTIVITY_BY_SEARCH,
    FETCH_ACTIVITY_POLYLINE,
    FETCH_ACTIVITY_POLYLINE_BAIDU,
    FETCH_ACTIVITY,
    FETCH_MULTIPLE_ACTIVITIES
} from '../actions/ActionTypes';
import {
    receiveActivityHrTimeInZones,
    receiveActivityPowerTimeInZones,
    receiveActivity,
    receiveChartOrder,
    requestActivity,
    receiveMultipleActivities,
    requestMultipleActivities
} from '../actions/activitiesActions';
import {
    receiveActivities,
    receiveActivitiesBySearch,
    receiveActivitiesBySearchError,
    receiveActivityHrTimeInZone,
    receiveActivityPolyline,
    receiveDeleteActivityBySearch,
    receiveFavoriteActivities,
    receiveFavoriteActivity,
    requestActivities,
    requestActivitiesBySearch,
    requestActivityHrTimeInZone,
    requestActivityPolyline,
    requestFavoriteActivities,
    setPageStatus
} from '../actions/index';
import { handlingErrorCallback, handlingSuccessCallback } from './sagasUtils';
import ActivityCompareUtil from 'Activity/ActivitiesCompare/ActivityCompareUtil';
import { gcApi, webApi } from '../config/axios';
import BaiduConvertService from 'Map/utils/BadiuConvertService.js';
import Garmin from 'garminmap';
import LocalizationUtil from 'utils/LocalizationUtil';

// worker
export function* fetchActivitySummary(action) {
    try {
        const { fromDate, toDate, groupByActivity } = action.payload;
        const queryParams = UrlUtil.toQueryString({
            fromDate: fromDate,
            untilDate: toDate,
            grpActType: groupByActivity
        });
        const response = yield call(gcApi.get, `/userstats-service/activities/summaryStats${queryParams}`);

        if (groupByActivity) {
            yield put({
                type: FETCH_ACTIVITY_SUMMARY_GROUPED_SUCCESS,
                activitySummary: response.data
            });
        } else {
            yield put({
                type: FETCH_ACTIVITY_SUMMARY_SUCCESS,
                activitySummary: response.data
            });
        }
    } catch (e) {
        // Handling Error
    }
}

export function* fetchActivitySummaryWeekly(action) {
    const { displayName, fromDate, toDate, groupByActivity } = action.payload;
    const queryParams = UrlUtil.toQueryString({
        fromWeekStartDate: fromDate,
        untilWeekStartDate: toDate,
        grpActType: groupByActivity
    });
    const response = yield call(gcApi.get, `/userstats-service/activities/weekly/${displayName}${queryParams}`);

    if (groupByActivity) {
        yield put({
            type: FETCH_ACTIVITY_SUMMARY_WEEKLY_GROUPED_SUCCESS,
            activitySummaryWeekly: response.data
        });
    } else {
        yield put({
            type: FETCH_ACTIVITY_SUMMARY_WEEKLY_SUCCESS,
            activitySummaryWeekly: response.data
        });
    }
}

export function* fetchActivitySummaryMonthly(action) {
    const { displayName, fromDate, toDate, groupByActivity } = action.payload;
    const queryParams = UrlUtil.toQueryString({
        fromMonthStartDate: fromDate,
        untilMonthStartDate: toDate,
        grpActType: groupByActivity
    });
    const response = yield call(gcApi.get, `/userstats-service/activities/monthly/${displayName}${queryParams}`);

    if (groupByActivity) {
        yield put({
            type: FETCH_ACTIVITY_SUMMARY_MONTHLY_GROUPED_SUCCESS,
            activitySummaryMonthly: response.data
        });
    } else {
        yield put({
            type: FETCH_ACTIVITY_SUMMARY_MONTHLY_SUCCESS,
            activitySummaryMonthly: response.data
        });
    }
}

export function* fetchActivitySummaryYearly(action) {
    const { displayName, fromDate, toDate, groupByActivity } = action.payload;
    const queryParams = UrlUtil.toQueryString({
        fromYear: fromDate,
        untilYear: toDate,
        grpActType: groupByActivity
    });
    const response = yield call(gcApi.get, `/userstats-service/activities/yearly/${displayName}${queryParams}`);

    if (groupByActivity) {
        yield put({
            type: FETCH_ACTIVITY_SUMMARY_YEARLY_GROUPED_SUCCESS,
            activitySummaryYearly: response.data
        });
    } else {
        yield put({
            type: FETCH_ACTIVITY_SUMMARY_YEARLY_SUCCESS,
            activitySummaryYearly: response.data
        });
    }
}

export function* fetchActivitySummaryStats(action) {
    const { fromDate, toDate, groupByActivity, groupByEvent } = action.payload;
    const queryParams = UrlUtil.toQueryString({
        fromDate: fromDate,
        untilDate: toDate,
        grpActType: groupByActivity,
        grpEventType: groupByEvent
    });
    const response = yield call(gcApi.get, `/userstats-service/activities/summaryStats${queryParams}`);

    if (groupByActivity) {
        yield put({
            type: FETCH_ACTIVITY_SUMMARY_STATS_ACTIVITY_SUCCESS,
            summaryStats: response.data
        });
    } else if (groupByEvent) {
        yield put({
            type: FETCH_ACTIVITY_SUMMARY_STATS_EVENT_SUCCESS,
            summaryStats: response.data
        });
    }
}

export function* submitActivityFeedBack(action) {
    try {
        const { feedBack, activityId } = action.payload;
        const response = yield call(gcApi.put, `/activity-service/activity/${activityId}`, {
            activityId: activityId,
            summaryDTO: {
                perceivedWorkoutEffort: feedBack
            }
        });

        yield put({
            type: SUBMIT_ACTIVITY_FEEDBACK_SUCCESS,
            activityFeedback: response.data,
            receivedAt: Date.now()
        });
    } catch (e) {
        // Handling Error
    }
}

export function* fetchActivityTypesSaga() {
    try {
        let response = yield gcApi.get('/activity-service/activity/activityTypes');
        // CA-136656: Slow migration from motorcycling to motorcycling_v2
        response.data = response.data.filter((activityType) => {
            return activityType.typeKey !== 'motorcycling';
        });
        yield put({
            type: RECEIVE_ACTIVITY_TYPES,
            activityTypes: response.data,
            receivedAt: Date.now()
        });
    } catch (e) {
        yield put({
            type: ACTIVITY_TYPES_FAIL,
            receivedAt: Date.now()
        });
    }
}

export function* fetchActivityHrTimeInZones({ activityId }) {
    try {
        const response = yield gcApi.get(`/activity-service/activity/${activityId}/hrTimeInZones`);
        yield put(receiveActivityHrTimeInZones(response.data, activityId));
    } catch (e) {}
}

export function* fetchActivityPowerTimeInZones({ activityId }) {
    try {
        const response = yield gcApi.get(`/activity-service/activity/${activityId}/powerTimeInZones`);
        yield put(receiveActivityPowerTimeInZones(response.data, activityId));
    } catch (e) {}
}

export function* fetchActivitySaga({ activityId, callback }) {
    try {
        yield put(requestActivity(activityId));
        const response = yield gcApi.get(`/activity-service/activity/${activityId}`);
        yield put(receiveActivity(response.data, activityId));
        yield call(handlingSuccessCallback, callback, response);
    } catch (e) {
        yield put(setPageStatus(e.response.status));
        yield call(handlingErrorCallback, callback, e);
    }
}

export function* fetchChartsOrder() {
    try {
        const response = yield webApi.get(`/web-data/activity-charts-order/activity-charts-order-master.json`, {
            baseURL: '/'
        });
        yield put(receiveChartOrder(response.data));
    } catch (e) {}
}

export function* fetchFavoriteActivitiesSaga({ displayName, limit }) {
    try {
        yield put(requestFavoriteActivities());
        const response = yield gcApi.get(
            `/activitylist-service/activities/favorite/${displayName}?limit=${limit ? limit : 5}`
        );
        yield put(receiveFavoriteActivities(response.data, displayName));
    } catch (e) {}
}

export function* fetchActivitiesSaga({ displayName, startIndex, limit }) {
    try {
        yield put(requestActivities(displayName));
        const response = yield gcApi.get(
            `/activitylist-service/activities/${displayName}?start=${startIndex ? startIndex : 1}&limit=${
                limit ? limit : 10
            }`
        );
        yield put(receiveActivities(response.data));
    } catch (e) {}
}

export function* fetchActivityHrTimeInZoneSaga({ activityId }) {
    try {
        yield put(requestActivityHrTimeInZone(activityId));
        const response = yield gcApi.get(`/activitylist-service/activity/${activityId}/hrTimeInZones`);
        yield put(receiveActivityHrTimeInZone(response.data));
    } catch (e) {}
}

export function* fetchActivitiesBySearchSaga({ parentActivityType, favorite, start, limit }) {
    try {
        yield put(requestActivitiesBySearch(REQUEST_ACTIVITIES_BY_SEARCH));
        const favoriteQuery = favorite ? '&favorite=1' : '';
        const startIndex = typeof start === 'number' ? `&start=${start}` : '';
        const queryLimit = limit ? `&limit=${limit}` : '';
        const response = yield gcApi.get(
            '/activitylist-service/activities/search/activities?activityType=' +
                parentActivityType +
                favoriteQuery +
                startIndex +
                queryLimit
        );
        yield put(receiveActivitiesBySearch(RECEIVE_ACTIVITIES_BY_SEARCH, response.data, parentActivityType, favorite));
    } catch (e) {
        yield put(receiveActivitiesBySearchError(RECEIVE_ACTIVITIES_BY_SEARCH_ERROR, e));
    }
}

export function* favoriteActivitySaga({ parentActivityType, activityDetails, favorite }) {
    try {
        const response = yield gcApi.put('/activity-service/activity/' + activityDetails.activityId, {
            activityId: activityDetails.activityId,
            metadataDTO: {
                favorite: favorite
            }
        });
        yield put(receiveFavoriteActivity(RECEIVE_FAVORITE_ACTIVITY, parentActivityType, activityDetails, favorite));
    } catch (e) {}
}

export function* deleteActivityBySearchSaga({ parentActivityType, activityDetails }) {
    try {
        const response = yield gcApi.delete('/activity-service/activity/' + activityDetails.activityId);
        yield put(
            receiveDeleteActivityBySearch(RECEIVE_DELETE_ACTIVITY_BY_SEARCH, parentActivityType, activityDetails)
        );
    } catch (e) {}
}

export function* fetchActivityPolylineSaga({ displayName, activityId }) {
    try {
        yield put(requestActivityPolyline(displayName));
        const response = yield gcApi.get(`/activity-service/activity/polyline/${activityId}`);
        yield put(receiveActivityPolyline(displayName, response.data, activityId));
    } catch (e) {}
}

/**
 * fetch activity polyline data for baidu map
 * @returns
 */
export function* fetchActivityPolylineForBaiduSaga(action) {
    const { displayName, activityId } = action;
    try {
        yield put(requestActivityPolyline(displayName));
        const response = yield gcApi.get(`/activity-service/activity/polyline/${activityId}`);

        if (!response.data?.gPolyline) {
            yield put(receiveActivityPolyline(displayName, response.data, activityId));
            return;
        }
        yield fork(processBaiduPolylineForProfile, displayName, activityId, response);
    } catch (e) {}
}

/**
 * convert polyline data to baidu map data points if necessary.
 * please currently this is for Profile Page only.
 * @param {string} displayName
 * @param {number} activityId
 * @param {import('axios').AxiosResponse} response
 * @returns
 */
export function* processBaiduPolylineForProfile(displayName, activityId, response) {
    // inject converted polyline points into response (this will be used directly on profile page)
    response.data.gPolyline.convertedPoints = [];

    let points = [];
    let disableConvert = null;
    let array = Garmin.Map.Utils.decodeLine(response.data.gPolyline.encodedSamples);
    for (let i = 0; i < array.length; i++) {
        let latlng = array[i];
        points.push({ latitude: latlng[0], longitude: latlng[1] });
    }

    for (let i = 0; i < points.length; i++) {
        if (LocalizationUtil.isOutOfChina(points[i].latitude, points[i].longitude)) {
            disableConvert = true;
            break;
        }
    }
    if (disableConvert) {
        /** no need to convert */
        yield put(receiveActivityPolyline(displayName, response.data, activityId));
        return;
    }

    const convertService = new BaiduConvertService();

    const convertedResponse = yield convertService.fetchGenerator(points);

    for (var i = 0; i < convertedResponse.length; i++) {
        response.data.gPolyline.convertedPoints.push({
            lat: Number(convertedResponse[i].lat),
            lon: Number(convertedResponse[i].lon)
        });
    }

    response.data.gPolyline.startLat = response.data.gPolyline.convertedPoints[0].lat;
    response.data.gPolyline.startLon = response.data.gPolyline.convertedPoints[0].lon;
    response.data.gPolyline.endLat = response.data.gPolyline.convertedPoints[convertedResponse.length - 1].lat;
    response.data.gPolyline.endLon = response.data.gPolyline.convertedPoints[convertedResponse.length - 1].lon;

    yield put(receiveActivityPolyline(displayName, response.data, activityId));
}

export function* fetchMultipleActivitiesSaga({ activitiesIds }) {
    yield put(requestMultipleActivities(activitiesIds));

    try {
        const activities = yield all(
            activitiesIds.map((activityId) => {
                return gcApi.get(`/activity-service/activity/${activityId}`);
            })
        );

        let splits = [];
        let reps = [];
        let polylines = [];
        let details = [];
        let weathers = [];

        activities.forEach((activity) => {
            if (
                ActivityCompareUtil.isRepCounting(activity.data.activityTypeDTO.typeKey) ||
                ActivityCompareUtil.isHiitActivity(activity.data.activityTypeDTO.typeKey)
            ) {
                reps.push(gcApi.get(`/activity-service/activity/${activity.data.activityId}/exerciseSets`));
            }

            splits.push(gcApi.get(`/activity-service/activity/${activity.data.activityId}/splits`));
            polylines.push(gcApi.get(`/activity-service/activity/polyline/${activity.data.activityId}`));
            details.push(
                gcApi.get(
                    `/activity-service/activity/${activity.data.activityId}/details?maxChartSize=2000&maxPolylineSize=4000`
                )
            );
            weathers.push(
                gcApi.get(`/activity-service/activity/${activity.data.activityId}/weather`, {
                    activityId: activity.data.activityId
                })
            );
        });

        const extras = yield all(
            [...splits, ...reps, ...polylines, ...details, ...weathers].map((p) => p.catch((error) => undefined))
        );

        let extraData = {};
        extras.forEach((dataset) => {
            if (!dataset) {
                return false;
            }

            const activityId = dataset.data.activityId || dataset.config.activityId;
            dataset.data.activityId = activityId; // until api fixes null value
            extraData[activityId]
                ? Object.assign(extraData[activityId], dataset.data)
                : (extraData[activityId] = dataset.data);

            if (dataset.data.gPolyline) {
                extraData[dataset.data.gPolyline.activityId]
                    ? Object.assign(extraData[dataset.data.gPolyline.activityId], dataset.data)
                    : (extraData[dataset.data.gPolyline.activityId] = dataset.data);
            }
        });

        yield put(
            receiveMultipleActivities(
                activities.map((activity) => {
                    return extraData[activity.data.activityId]
                        ? Object.assign(activity.data, extraData[activity.data.activityId])
                        : activity.data;
                })
            )
        );
    } catch (e) {}
}

// watcher
export const activitySagas = [
    takeEvery(FETCH_ACTIVITY_SUMMARY, fetchActivitySummary),
    takeEvery(FETCH_ACTIVITY_SUMMARY_WEEKLY, fetchActivitySummaryWeekly),
    takeEvery(FETCH_ACTIVITY_SUMMARY_MONTHLY, fetchActivitySummaryMonthly),
    takeEvery(FETCH_ACTIVITY_SUMMARY_YEARLY, fetchActivitySummaryYearly),
    takeEvery(FETCH_ACTIVITY_SUMMARY_STATS, fetchActivitySummaryStats),
    takeEvery(SUBMIT_ACTIVITY_FEEDBACK, submitActivityFeedBack),
    takeEvery(REQUEST_ACTIVITY_TYPES, fetchActivityTypesSaga),
    takeEvery(REQUEST_ACTIVITY_HR_TIME_IN_ZONE, fetchActivityHrTimeInZones),
    takeEvery(REQUEST_ACTIVITY_POWER_TIME_IN_ZONE, fetchActivityPowerTimeInZones),
    takeEvery(FETCH_ACTIVITY, fetchActivitySaga),
    takeEvery(FETCH_CHARTS_ORDER, fetchChartsOrder),
    takeEvery(FETCH_FAVORITE_ACTIVITIES, fetchFavoriteActivitiesSaga),
    takeEvery(FETCH_ACTIVITIES, fetchActivitiesSaga),
    takeEvery(FETCH_ACTIVITY_HR_TIME_IN_ZONE, fetchActivityHrTimeInZoneSaga),
    takeEvery(FETCH_ACTIVITIES_BY_SEARCH, fetchActivitiesBySearchSaga),
    takeEvery(FAVORITE_ACTIVITY, favoriteActivitySaga),
    takeEvery(DELETE_ACTIVITY_BY_SEARCH, deleteActivityBySearchSaga),
    takeEvery(FETCH_ACTIVITY_POLYLINE, fetchActivityPolylineSaga),
    takeEvery(FETCH_ACTIVITY_POLYLINE_BAIDU, fetchActivityPolylineForBaiduSaga),
    takeEvery(FETCH_MULTIPLE_ACTIVITIES, fetchMultipleActivitiesSaga)
];
